






























































































































































































































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import axios from "axios";
const instance = axios.create({
	// headers: {'X-Custom-Header': 'foobar'}
});
import RtRadio from "@/components/base/RtRadio.vue";
import DateSelect from "@/components/coupon/DateSelect.vue";

const couponModule = namespace("coupon");

@Component({
	components: {
		RtRadio,
		DateSelect,
	},
})
export default class CouponAdd extends Vue {
	@couponModule.Getter("CATEGORY") CATEGORY!: Array<any>;
	@couponModule.Getter("CATEGORY_VALUE") CATEGORY_VALUE!: any;
	minDate: Date = new Date();

	form = {
		couponBusinessEntityId: "",					//在addCoupon接口中自动赋值;
		couponBusinessEntityTypeId: "",				//在addCoupon接口中自动赋值;
		couponBusinessEntityName: "",				//在addCoupon接口中自动赋值;
		couponOperateBusinessEntityId: "",			//在addCoupon接口中自动赋值;
		couponOperateBusinessEntityTypeId: "",		//在addCoupon接口中自动赋值;
		couponOperateBusinessEntityName: "",		//在addCoupon接口中自动赋值;


		couponParkingDeduction: 1,					//[停车券]0:时长, 1:金额(默认)
		couponParkingDuration: 0,					//[停车券][couponParkingDeduction为0时有效]停车时长(分)
		isAnonymousCoupon: 0,						//[停车券]0:电子券, 1:实体券

		couponIsCharge: 0,							//[通用券]0:免费(默认), 1:收费

		couponEffectiveEntityLimitType: 3,			//[强制为3]1:全部关联主体(默认), 2:部分主体, 3:仅本主体
		couponEntityList: [],						//[强制为空列表]核销主体列表
		
		couponOverlaySwitch: 0,						//0:不叠加(默认), 1:叠加
		couponOverlayMore: 0,						//[couponOverlaySwitch为1时有效]0:不叠加门槛, 1:叠加门槛

		couponIsOnline: 1,							//1:通用, 2:线上, 3:线下

		couponEffectiveCategoryLimitSwitch: 0,		//0:不限(默认) 1:自定义
		couponEffectiveCategoryLimitId: "",			//[默认为空字符串]核销品类ID
		couponEffectiveCategoryLimitIdSwitch: 0,	//[线上未实现此功能]0:品类ID(默认), 1:商品ID
		couponEffectiveCategoryLimitIds:"",			//[线上未实现此功能][默认为空字符串]核销限制ID
		
		couponPrecouponSwitch: 0,					//0:不使用(默认), 1:使用外部券ID, 2:使用crm券码
		couponPrecouponId: "",						//[couponPrecouponSwitch为1时有效]外部券ID
		preCouponList: [],							//[couponPrecouponSwitch为1时有效]外部劵码列表
		crmCouponCode: "",							//[couponPrecouponSwitch为2时有效]crm外部券编码

		couponExtendContentSwitch: 0,				//[线上未实现此功能]0:不携带扩展内容(默认), 1:携带扩展内容
		couponExtendContent: "",					//[线上未实现此功能][couponExtendContentSwitch为1时有效]携带扩展内容
		extendContentList: [],						//[线上未实现此功能]携带扩展内容列表
		
		couponShopGoodsVoList: [],					//[强制为空列表]券使用商户下的商品集合
		couponPutinBusinessEntityId: null,			//[线上未实现此功能]券投放主体ID
		couponPutinBusinessEntityName: null,		//[线上未实现此功能]券投放主体名称


		couponCategoryId: "", //券类型
		couponName: "", //券名称
		couponDiscount: "", //折扣
		couponMainInfo: "", //主标题
		couponExtendInfo: "", //副标题
		couponDisplayTimeSwitch: 0, //展示有效期开关
		couponDisplayStartTime: "", //展示有效期
		couponDisplayEndTime: "", //展示有效期
		couponGetStartTime: "", //领取有效期
		couponGetEndTime: "", //领取有效期
		couponGetTimeLimitSwitch: 0, //领取时段限制开关
		getTimeLimitWeekList: [], //领取时段限制周
		getTimeLimitTimeList: [
			{
				startTime: "08:00",
				endTime: "09:00",
			},
		], //领取时段限制时间段
		couponEffectiveSwitch: 0, //核销有效日期类型
		couponEffectiveStartTime: "", //核销有效开始日期
		couponEffectiveEndTime: "", //核销有效结束日期
		couponActivedLimitedStartDay: "0", //领取后多少天生效
		couponActivedLimitedDays: "1", //领取后有效天数
		couponEffectiveTimeLimitSwitch: 0, //
		effectiveTimeLimitWeekList: [], //
		effectiveTimeLimitTimeList: [
			{
				startTime: "08:00",
				endTime: "09:00",
			},
		], //
		couponEffectiveConditionSwitch: 0, //门槛开关
		couponEffectiveConditionPrice: "", //门槛(金额)
		couponQuantity: "", //券数量
		couponFacePrice: "", //券金额
		couponUnitPrice: "", //原价
		couponCost: "", //成本
		couponDayLimitNumSwitch: 0, //每人每天领取限制开关
		couponDayLimitNum: "", //每人每天领取限制数
		couponCumulativeLimitNumSwitch: 0, //每人累计领取限制开关
		couponCumulativeLimitNum: "", //每人累计领取限制数
		couponMarginWarningSwitch: 0, //券余量预警开关
		couponMarginWarningQuantity: 0, //劵余量预警数
		couponDescClause: "", //使用说明
		imageInfoVoList: [
			{
				img: "",
				html: "",
			},
		],
		photoUriList: Array<{ url: string }>(),
	};
	imageInfoVoListIndex = 0;

	list = [
		{ label: "周一", value: "1" },
		{ label: "周二", value: "2" },
		{ label: "周三", value: "3" },
		{ label: "周四", value: "4" },
		{ label: "周五", value: "5" },
		{ label: "周六", value: "6" },
		{ label: "周日", value: "7" },
	];
	result = ["a", "b"];
	parkingTypeOption = [
		{ label: "金额", value: 1 },
		{ label: "时长", value: 0 },
	];
	overlaySwitchOption = [
		{ label: "不叠加使用", value: 0 },
		{ label: "可叠加使用", value: 1 },
	];
	onlineOption = [
		{ label: "通用", value: 1 },
		{ label: "线上", value: 2 },
		{ label: "线下", value: 3 },
	];
	showOption = [
		{ label: "不限", value: 0 },
		{ label: "自定义时间", value: 1 },
	];
	showOptions = [
		{ label: "不限", value: 0 },
		{ label: "自定义预警", value: 1 },
	];
	writeOption = [
		{ label: "选择时间", value: 0 },
		{ label: "领取后有效", value: 1 },
	];
	EffectiveCategoryOption = [
		{ label: "不限", value: 0 },
		{ label: "自定义品类", value: 1 },
	];
	limitOption = [
		{ label: "不限", value: 0 },
		{ label: "指定张数", value: 1 },
	];
	useOption = [
		{ label: "无门槛", value: 0 },
		{ label: "使用门槛", value: 1 },
	];
	precouponOption = [
		{ label: "不使用", value: 0 },
		{ label: "自定义", value: 1 },
		{ label: "礼品券", value: 2 },
	];
	couponCategoryIdDesc = "";
	preCouponListInput = "";
	showPicker = false;
	columns = ["杭州", "宁波", "温州", "嘉兴", "湖州"];
	
	get action() {
		return this.$http["FILE_UPLOAD"].api;
	}

	get buttonTitle(){
		if (this.$route.meta.copy && this.$route.params.id) {
			return "复 制"
		}
		return "创 建"
	}

	setCouponActivedLimitedDays(e: any) {
		console.log(e);
		if (e.data && e.data <= 0) {
			this.form.couponActivedLimitedDays = "1";
		}
	}

	addGetTime() {
		this.form.getTimeLimitTimeList.push({
			startTime: "08:00",
			endTime: "09:00",
		});
	}

	deleteGetTime(index: any) {
		this.form.getTimeLimitTimeList.splice(index, 1);
	}

	addEffectiveTime() {
		this.form.effectiveTimeLimitTimeList.push({
			startTime: "08:00",
			endTime: "09:00",
		});
	}

	deleteEffectiveTime(index: any) {
		this.form.effectiveTimeLimitTimeList.splice(index, 1);
	}

	del(url: any) {
		let index = (this.form.photoUriList||[]).indexOf(url);
		if(index >= 0){
			this.form.photoUriList.splice(index, 1);
		}
	}
	delfo(url: any) {
		// debugger;
		let index = (this.form.photoUriList||[]).indexOf(url);
		if(index >= 0){
			this.form.imageInfoVoList.splice(index, 1);
		}
	}
	onConfirm(value: any) {
		this.couponCategoryIdDesc = value.label;
		this.form.couponCategoryId = value.value;
		this.showPicker = false;
	}
	onCouponMainInfoChange(){
		const getNum = (num: any) => (Number(num) == num ? Number(num) : 0);
		switch(this.form.couponCategoryId){
			case this.CATEGORY_VALUE.DISCOUNT:
				this.form.couponMainInfo = `${getNum(this.form.couponDiscount)}折折扣券`;
				break;
			case this.CATEGORY_VALUE.CASH:
				this.form.couponMainInfo = `${getNum(this.form.couponFacePrice)}元代金券`;
				break;
			case this.CATEGORY_VALUE.PARKING:
				if(this.form.couponParkingDeduction == 0){
					this.form.couponMainInfo = `${getNum(Number((this.form.couponParkingDuration / 60).toFixed(2)))}小时停车券`;
				}
				if(this.form.couponParkingDeduction == 1){
					this.form.couponMainInfo = `${getNum(this.form.couponFacePrice)}元停车券`;
				}
				break;
		}
	}
	onPreCodeInput(){
		const preCouponList:any = (this.preCouponListInput||"").match(/[^\s\r\n]+/gi) || [];
		if(preCouponList.length > 5000){
			this.form.preCouponList = preCouponList.slice(0, 50000);
		}else{
			this.form.preCouponList = preCouponList;
		}
	}
	async uploader(val: any) {
		const param = new FormData();
		param.append("file", val.file);

		instance
			.post(this.action, param, {
				headers: {
					"Content-Type": "multipart/form-data",
					token: this.$global.token,
					tenantId: this.$global.tenantId,
					tenantType: this.$global.tenantType,
				},
			})
			.then((res) => {
				this.form.photoUriList.push({ url: res.data.data.path });
			});
	}
	addImgText() {
		this.form.imageInfoVoList.push({
			img: "",
			html: "",
		});
	}
	filteremoji(emojireg: any) {
		const ranges = [
			"\ud83c[\udf00-\udfff]",
			"\ud83d[\udc00-\ude4f]",
			"\ud83d[\ude80-\udeff]",
		];
		return (emojireg = emojireg.replace(
			new RegExp(ranges.join("|"), "g"),
			""
		));
	}
	uploaderImg(val: any, index: any) {
		//图文图片上传
		console.log(index);
		const param = new FormData();
		param.append("file", val.file);
		instance
			.post(this.action, param, {
				headers: {
					"Content-Type": "multipart/form-data",
					token: this.$global.token,
					tenantId: this.$global.tenantId,
					tenantType: this.$global.tenantType,
				},
			})
			.then((res) => {
				this.form.imageInfoVoList[this.imageInfoVoListIndex].img =
					res.data.data.path;
			});
	}
	uploaderImgClick(index: any) {
		this.imageInfoVoListIndex = index;
	}

	async creat() {
		if (this.form.photoUriList.length == 0) {
			return (this as any).$notify({
				title: "",
				message: "请上传封面图片",
			});
		}
		if (this.form.couponEffectiveSwitch == 1) {
			if (
				!this.form.couponActivedLimitedDays ||
				this.form.couponActivedLimitedDays < "1"
			) {
				return (this as any).$notify({
					title: "",
					message: "有效期最少一天",
				});
			}
		}

		if (
			Number(this.form.couponDiscount) < 10 &&
			this.form.couponCategoryId == this.CATEGORY_VALUE.DISCOUNT
		) {
			return (this as any).$notify({
				title: "",
				message: "请输入正确的折扣百分比",
			});
		}

		this.form.imageInfoVoList.map((item: any) => {
			//couponDescClause
			item.html = this.filteremoji(item.html);
			return item.html;
		});
		this.form.couponDescClause = this.filteremoji(
			this.form.couponDescClause
		);
		let params = JSON.parse(JSON.stringify(this.form));
		const { error, success }: any = await this.$store.dispatch(
			"coupon/addCoupon",
			params
		);
		if (success) {
			(this as any).$notify({ type: "success", message: success.msg });
			this.$router.push("/coupon/list");
		}
		error && (this as any).$notify(error.msg);
	}

	createHandler() {
		this.$router.push("/coupon/list");
	}
	mounted() {
		this.$store.dispatch("coupon/getCategoryList");
		if (this.$route.meta.copy && this.$route.params.id) {
			this.onCouponCopyInit();
		}
	}
	async onCouponCopyInit() {
		const params: any = { couponId: this.$route.params.id };
		const { error, success }: any = await this.$request(
			"COUPON_INFO",
			params
		);
		if (success) {
			const data = success.data;
			this.couponCategoryIdDesc = data.couponCategoryIdDesc;
			this.form.couponCategoryId = data.couponCategoryId;
			this.form.couponName = data.couponName;
			this.form.couponDiscount = data.couponDiscount;
			this.form.couponMainInfo = data.couponMainInfo;
			this.form.couponExtendInfo = data.couponExtendInfo;
			this.form.couponDisplayTimeSwitch = data.couponDisplayTimeSwitch;
			this.form.couponDisplayStartTime = data.couponDisplayStartTime;
			this.form.couponDisplayEndTime = data.couponDisplayEndTime;
			this.form.couponGetStartTime = data.couponGetStartTime;
			this.form.couponGetEndTime = data.couponGetEndTime;
			this.form.couponGetTimeLimitSwitch = data.couponGetTimeLimitSwitch;
			this.form.getTimeLimitWeekList = data.getTimeLimitWeekList || [];
			this.form.getTimeLimitTimeList = data.getTimeLimitTimeList || [];
			this.form.couponEffectiveSwitch = data.couponEffectiveSwitch;
			this.form.couponEffectiveStartTime = data.couponEffectiveStartTime;
			this.form.couponEffectiveEndTime = data.couponEffectiveEndTime;
			this.form.couponActivedLimitedStartDay = data.couponActivedLimitedStartDay;
			this.form.couponActivedLimitedDays = data.couponActivedLimitedDays;
			this.form.couponEffectiveTimeLimitSwitch = data.couponEffectiveTimeLimitSwitch;
			this.form.effectiveTimeLimitWeekList = data.effectiveTimeLimitWeekList || [];
			this.form.effectiveTimeLimitTimeList = data.effectiveTimeLimitTimeList || [];
			this.form.couponEffectiveConditionSwitch = data.couponEffectiveConditionSwitch;
			this.form.couponEffectiveConditionPrice = String(data.couponEffectiveConditionPrice/100);
			this.form.couponQuantity = data.couponQuantity;
			this.form.couponFacePrice = String(data.couponFacePrice/100);
			this.form.couponUnitPrice = String(data.couponUnitPrice/100);
			this.form.couponCost = String(data.couponCost/100);
			this.form.couponDayLimitNumSwitch = data.couponDayLimitNumSwitch;
			this.form.couponDayLimitNum = data.couponDayLimitNum;
			this.form.couponCumulativeLimitNumSwitch = data.couponCumulativeLimitNumSwitch;
			this.form.couponCumulativeLimitNum = data.couponCumulativeLimitNum;
			this.form.couponMarginWarningSwitch = data.couponMarginWarningSwitch;
			this.form.couponMarginWarningQuantity = data.couponMarginWarningQuantity;
			this.form.couponDescClause = data.couponDescClause;
			this.form.imageInfoVoList = (data.imageInfoVoList || []).reduce((prev:any, curr:any) => {
				if(prev.length){
					let compare = prev.pop();

					let imgValid = (compare.img && !curr.img) || (!compare.img && curr.img);
					let htmlValid = (compare.html && !curr.html) || (!compare.html && curr.html);

					if(imgValid && htmlValid){
						compare.img = compare.img || curr.img;
						compare.html = compare.html || curr.html;
						return [ ...prev, compare ];
					}else{
						return [ ...prev, compare, curr ];
					}
				}else{
					return [curr];
				}
			}, []);
			this.form.photoUriList = (data.photoUriList||[]).map((url:string) => { return {url}; });

			/** 以下为新增加的功能字段 */
			
			this.form.couponParkingDeduction = data.couponParkingDeduction;
			this.form.couponParkingDuration = data.couponParkingDuration;
			this.form.isAnonymousCoupon = data.isAnonymousCoupon;

			this.form.couponIsCharge = data.couponIsCharge;

			this.form.couponOverlaySwitch = data.couponOverlaySwitch;
			this.form.couponOverlayMore = data.couponOverlayMore;

			this.form.couponIsOnline = data.couponIsOnline;

			this.form.couponEffectiveCategoryLimitSwitch = data.couponEffectiveCategoryLimitSwitch;
			this.form.couponEffectiveCategoryLimitId = data.couponEffectiveCategoryLimitId;

			this.form.couponPrecouponSwitch = data.couponPrecouponSwitch;
			this.form.couponPrecouponId = data.couponPrecouponId;
			this.form.preCouponList = data.preCouponList;
			this.form.crmCouponCode = data.crmCouponCode;

			this.preCouponListInput = (data.preCouponList || []).join('\r');
		}
		if (error) {
			this.$toast({
				type: "fail",
				message: error.msg || error.message,
			});
		}
	}
}
